import React, { useEffect, useState, useRef } from "react";

import axios from "config/axiosConfig";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import dateFormat from "dateformat";
import { Editor } from "@tinymce/tinymce-react";

export default function Edit() {
    const [industries, setIndustries] = useState([]);
    const [writingTagText, setWritingTagText] = useState('');
    const [inputSupportType, setInputSupportType] = useState('');
    const [inputTitle, setInputTitle] = useState('');
    const [inputIndustries, setInputIndustries] = useState([]);
    const [inputRegion, setInputRegion] = useState('');
    const [inputCeoAge, setInputCeoAge] = useState('');
    const [inputFourMajorInsurance, setInputFourMajorInsurance] = useState('');
    const [inputStartDate, setInputStartDate] = useState('');
    const [inputEndDate, setInputEndDate] = useState('');
    const [inputTags, setInputTags] = useState([]);
    const [inputImageUrl, setInputImageUrl] = useState();

    const [inputVisible, setInputVisible] = useState('true');
    const [inputVisibleStartAt, setInputVisibleStartAt] = useState();
    const [inputPinned, setInputPinned] = useState(false);

    const [htmlContent, setHtmlContent] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const editorRef = useRef(null);

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    useEffect(() => {
        if (id != null) {
            axios.get("/admin/policy-support/projects/" + id)
                .then((res) => {
                    setInputSupportType(res.data.supportType);
                    setInputTitle(res.data.title);
                    setInputIndustries(res.data.industries.map(item => item.name));
                    setInputRegion(res.data.region);
                    setInputCeoAge(res.data.ceoAge);
                    setInputFourMajorInsurance(res.data.fourMajorInsurance);
                    setInputStartDate(res.data.startDate);
                    setInputEndDate(res.data.endDate);
                    setInputTags(res.data.tags.map(item => item.name));
                    setHtmlContent(res.data.htmlContent);
                    setInputVisibleStartAt(res.data.visibleStartAt ? new Date(res.data.visibleStartAt) : null);
                    setInputVisible(res.data.visible);
                    setInputPinned(res.data.pinned === true);
                });
        }

        axios.get(`/admin/policy-support/industries`)
            .then((res) => {
                setIndustries(res.data);
            });
    }, []);

    const requestSave = () => {
        if (inputSupportType === '') {
            alert("지원유형을 선택해주세요.");
            return;
        }

        var newHtmlContent = editorRef.current?.getContent() || htmlContent;
        newHtmlContent = removeTableStyles(newHtmlContent);

        const params = {
            supportType: inputSupportType,
            title: inputTitle,
            visible: inputVisible,
            pinned: inputPinned,
            tags: inputTags,
            htmlContent: newHtmlContent,
            imageUrl: getEditorFirstImageUrl(),
        };

        if (inputSupportType === 'SUPPORT_PROGRAMS') {
            params.industries = inputIndustries;
            params.region = inputRegion;
            params.ceoAge = inputCeoAge;
            params.fourMajorInsurance = inputFourMajorInsurance;
            params.startDate = dateFormat(inputStartDate, 'yyyy-mm-dd');
            params.endDate = inputEndDate;
        }

        Object.keys(params).forEach((key) => {
            if (params[key] === '') {
                params[key] = null;
            }
        });

        if (id !== null) {
            params.id = id;
            axios.put('/admin/policy-support/projects', JSON.stringify(params))
                .then(() => {
                    alert('정책지원 사업이 수정되었습니다.');
                    document.location.reload();
                });
        } else {
            axios.post('/admin/policy-support/projects', JSON.stringify(params))
                .then(() => {
                    alert('정책지원 사업이 생성되었습니다.');
                    navigate('/page/policy-support/main');
                });
        }
    }

    const handleInputIndustry = (e) => {
        if (e.target.checked) {
            setInputIndustries([...inputIndustries, e.target.value]);
        } else {
            setInputIndustries(inputIndustries.filter(name => name !== e.target.value));
        }
    }

    const handleInputIndustryCheckAll = () => {
        if (inputIndustries.length === industries.length) {
            setInputIndustries([]);
        } else {
            setInputIndustries(industries.map(item => item.name));
        }
    }

    const handleAddTag = () => {
        if (!writingTagText || inputTags.includes(writingTagText)) {
            setWritingTagText('');
            return;
        }
        setInputTags([...inputTags, writingTagText]);
        setWritingTagText('');
    }

    const handleRemoveTag = (index) => {
        setInputTags(inputTags.filter((_, i) => i !== index));
    }

    const isIndustryChecked = (name) => inputIndustries.includes(name);

    const getEditorFirstImageUrl = () => {
        const html = editorRef.current?.getContent();
        if (!html) return null;

        const div = document.createElement('div');
        div.innerHTML = html;

        const firstImg = div.querySelector('img');
        return firstImg?.src || null;
    };
    const extractEditorImageUrls = () => {
        const html = editorRef.current?.getContent();
        if (!html) return [];

        const div = document.createElement('div');
        div.innerHTML = html;

        const imgs = div.querySelectorAll('img');

        return Array.from(imgs).map(img => img.src);
    };

    function removeTableStyles(html) {
        const div = document.createElement("div");
        div.innerHTML = html;

        // 지정한 태그들 모두 찾기
        const targets = div.querySelectorAll("table, tr, td, th, col, colgroup");

        targets.forEach(el => {
            el.removeAttribute("style");
        });

        return div.innerHTML;
    }

    const editorContentStyle = `
          body {
            padding: 10px !important;
            margin: 0 !important;
            box-sizing: border-box;
          }
          img {
            max-width: 100%;
            height: auto;
            display: block;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          table, th, td {
            border: 1px solid #ccc;
          }
          body {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 14px;
            line-height: 1.5;
            margin: 0;
            padding: 0;
          }
          p {
            margin: 0 0 1em;
          }
        `;

    const editorPreviewStyle = `
          img {
            max-width: 100%;
            height: auto;
            display: block;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          table, th, td {
            border: 1px solid #ccc;
          }
          body {
            font-family: Arial, Helvetica, sans-serif;
            font-size: 14px;
            line-height: 1.5;
            margin: 0;
            padding: 0;
          }
          p {
            margin: 0 0 1em;
          }
        `;

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">자영업 정보센터</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">

                                            <div className="form-group row">
                                                <label htmlFor="searchText"
                                                       className="col-sm-1 col-form-label">지원유형</label>
                                                <div className="col-2">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={e => setInputSupportType(e.target.value)}
                                                            value={inputSupportType}>
                                                        <option value="">미선택</option>
                                                        <option value="MUST_KNOW_FOR_RUNNING">장사중 챙길 것들</option>
                                                        <option value="SUPPORT_PROGRAMS">지원사업 모아보기</option>
                                                        <option value="BUSINESS_ISSUES">자영업 이슈</option>
                                                        <option value="BEGINNER_GUIDE">초보사장님 필독</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="searchText"
                                                       className="col-sm-1 col-form-label">제목</label>
                                                <div className="col-sm">
                                                    <input type="text" className="form-control" id="searchText"
                                                           onChange={e => setInputTitle(e.target.value)}
                                                           value={inputTitle}/>
                                                </div>
                                            </div>

                                            {
                                                inputSupportType === 'SUPPORT_PROGRAMS' && (
                                                    <div className="form-group row">
                                                        <label className="col-sm-1 col-form-label">업종</label>
                                                        {
                                                            industries && industries.map(item => {
                                                                return (
                                                                    <div className="form-check" style={{marginLeft: "20px"}}>
                                                                        <input id={item.name} className="form-check-input"
                                                                               type="checkbox"
                                                                               checked={isIndustryChecked(item.name)}
                                                                               onChange={handleInputIndustry}
                                                                               value={item.name}
                                                                        />
                                                                        <label className="form-check-label"
                                                                               style={{marginLeft: "-3px"}}
                                                                               htmlFor={item.name}>{item.name}</label>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className="form-check" style={{marginLeft: "20px"}}>
                                                            <input id="industryCheckAll" className="form-check-input"
                                                                   type="checkbox"
                                                                   checked={inputIndustries.length === industries.length}
                                                                   onChange={handleInputIndustryCheckAll}
                                                            />
                                                            <label className="form-check-label"
                                                                   style={{marginLeft: "-3px"}}
                                                                   htmlFor="industryCheckAll">모두선택</label>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                inputSupportType === 'SUPPORT_PROGRAMS' && (
                                                    <div className="form-group row">
                                                        <label htmlFor="tagText"
                                                               className="col-sm-1 col-form-label">선택</label>

                                                        <label className="col-sm-auto col-form-label"
                                                               style={{marginLeft: '10px'}}>지역</label>
                                                        <div className="col-2">
                                                            <select className="form-control"
                                                                    style={{width: '200px', marginRight: '10px'}}
                                                                    onChange={e => setInputRegion(e.target.value)}
                                                                    value={inputRegion}>
                                                                <option value="">미선택</option>
                                                                <option value="CAPITAL">수도권</option>
                                                                <option value="NO_CAPITAL">수도권 외</option>
                                                            </select>
                                                        </div>

                                                        <label className="col-sm-auto col-form-label">대표자 나이</label>
                                                        <div className="col-2">
                                                            <select className="form-control"
                                                                    style={{width: '200px', marginRight: '10px'}}
                                                                    onChange={e => setInputCeoAge(e.target.value)}
                                                                    value={inputCeoAge}>
                                                                <option value="">미선택</option>
                                                                <option value="THIRTY_NINE_BELOW">만 39세 이하</option>
                                                                <option value="THIRTY_NINE_OVER">만 39세 초과</option>
                                                            </select>
                                                        </div>

                                                        <label className="col-sm-auto col-form-label">4대보험 신고여부</label>
                                                        <div className="col-2">
                                                            <select className="form-control"
                                                                    style={{width: '200px', marginRight: '10px'}}
                                                                    onChange={e => setInputFourMajorInsurance(e.target.value)}
                                                                    value={inputFourMajorInsurance}>
                                                                <option value="">미선택</option>
                                                                <option value="true">여</option>
                                                                <option value="false">부</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                inputSupportType === 'SUPPORT_PROGRAMS' && (
                                                    <div className="form-group row">
                                                        <label htmlFor="linkText"
                                                               className="col-sm-1 col-form-label">일정</label>

                                                        <label className="col-sm-auto col-form-label"
                                                               style={{marginLeft: '10px'}}>시작일</label>
                                                        <div style={{width: '245px', marginTop: '2px'}}>
                                                            <DatePicker
                                                                dateFormat="yyyy-MM-dd"
                                                                dateFormatCalendar="yyyy년 MM월"
                                                                locale="ko"
                                                                selected={inputStartDate}
                                                                onChange={date => setInputStartDate(date)}
                                                            />
                                                        </div>

                                                        <label className="col-sm-auto col-form-label">종료일</label>
                                                        <div style={{width: '200px'}}>
                                                            <input type="text" className="form-control"
                                                                   onChange={e => setInputEndDate(e.target.value)}
                                                                   value={inputEndDate}/>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            <div className="form-group row">
                                                <label htmlFor="tagText"
                                                       className="col-sm-1 col-form-label">태그</label>
                                                <div className="col-sm">
                                                    {
                                                        inputTags && inputTags.map((item, index) => {
                                                            return (
                                                                <button type="button" className="btn btn-outline-dark"
                                                                        style={{marginLeft: '10px'}}
                                                                        onClick={() => handleRemoveTag(index)}>
                                                                    #{item}
                                                                </button>
                                                            )
                                                        })
                                                    }
                                                    <input type="text" className="form-control col-1"
                                                           style={{display: 'inline-block', marginLeft: '10px'}}
                                                           onChange={e => setWritingTagText(e.target.value)}
                                                           // onKeyDown={writeTagTextActiveEnter}
                                                           value={writingTagText}/>
                                                    <button type="button" className="btn btn-outline-dark"
                                                            style={{marginLeft: '5px'}}
                                                            onClick={handleAddTag}>
                                                        추가
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-1 col-form-label">인기글 우선 노출</label>
                                                <div className="col-sm-auto" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="pinnedOptions" id="pinnedOn" value="on"
                                                               checked={inputPinned === true}
                                                               onChange={() => setInputPinned(true)} />
                                                        <label className="form-check-label" htmlFor="pinnedOn">ON</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="pinnedOptions" id="pinnedOff" value="off"
                                                               checked={inputPinned === false}
                                                               onChange={() => setInputPinned(false)} />
                                                        <label className="form-check-label" htmlFor="pinnedOff">OFF</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="linkText"
                                                       className="col-sm-1 col-form-label">노출</label>

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '0px'}}>노출시작시간</label>
                                                <div className="col-2">
                                                    <DatePicker
                                                        dateFormat="yyyy-MM-dd HH:mm"
                                                        dateFormatCalendar="yyyy년 MM월"
                                                        showTimeSelect
                                                        timeIntervals={30}
                                                        locale="ko"
                                                        selected={inputVisibleStartAt}
                                                        onChange={(date) => {
                                                            setInputVisibleStartAt(date);
                                                        }}
                                                    />
                                                </div>

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '0px'}}>노출여부</label>
                                                <div className="col-2">
                                                    <select className="form-control"
                                                            style={{width: '200px', marginRight: '10px'}}
                                                            onChange={e => setInputVisible(e.target.value)}
                                                            value={inputVisible}>
                                                        <option value="true">노출</option>
                                                        <option value="false">미노출</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-1 col-form-label">설명</label>
                                                <div className="col-sm">
                                                    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                                                        {/* 왼쪽 에디터 */}
                                                        <div style={{ width: '430px' }}>
                                                            <Editor
                                                                apiKey="h12atoudv899warcfuxxoxf6ahk9ewey10bcseqchevm7yji"
                                                                onInit={(evt, editor) => (editorRef.current = editor)}
                                                                value={htmlContent}
                                                                init={{
                                                                    content_style: editorContentStyle,
                                                                    height: 700,
                                                                    menubar: true,
                                                                    plugins: [
                                                                        'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview',
                                                                        'anchor', 'pagebreak', 'searchreplace', 'wordcount', 'visualblocks',
                                                                        'visualchars', 'code', 'fullscreen', 'insertdatetime', 'media', 'table'
                                                                    ],
                                                                    toolbar:[
                                                                        'undo redo | styles | bold italic link image | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent table',
                                                                    ],
                                                                    automatic_uploads: true,
                                                                    image_title: false,
                                                                    image_dimensions: false,
                                                                    file_picker_types: 'image',
                                                                    file_picker_callback: async (callback, value, meta) => {
                                                                        if (meta.filetype === 'image') {
                                                                            const input = document.createElement('input');
                                                                            input.setAttribute('type', 'file');
                                                                            input.setAttribute('accept', 'image/*');

                                                                            input.onchange = async () => {
                                                                                const file = input.files[0];
                                                                                const formData = new FormData();
                                                                                formData.append('file', file);
                                                                                const res = await axios.post('/admin/editor/upload/image', formData, {
                                                                                    headers: {'Content-Type': 'multipart/form-data'},
                                                                                    withCredentials: true,
                                                                                });
                                                                                const url = res.data.location;
                                                                                callback(url);
                                                                            };

                                                                            input.click();
                                                                        }
                                                                    }
                                                                }}
                                                                onEditorChange={(content) => setHtmlContent(content)}
                                                            />
                                                        </div>

                                                        {/* 오른쪽: 미리보기 */}
                                                        <div style={{ width: '430px', marginTop: '167px' }}>
                                                            <style>{`
                                                                .tinymce-preview img {
                                                                  max-width: 100%;
                                                                  height: auto;
                                                                  display: block;
                                                                }
                                                                .tinymce-preview table {
                                                                  border-collapse: collapse;
                                                                  width: 100%;
                                                                }
                                                                .tinymce-preview th, .tinymce-preview td {
                                                                  border: 1px solid #ccc;
                                                                  padding: 8px;
                                                                  line-height: 1.2;
                                                                  vertical-align: top;
                                                                }
                                                              `}</style>
                                                            <style>{editorPreviewStyle}</style>
                                                            <div
                                                                className="tinymce-preview"
                                                                style={{
                                                                    width: '100%',
                                                                    minHeight: 542,
                                                                    // maxHeight: 542,
                                                                    // overflowY: 'auto',
                                                                    overflowY: 'visible',
                                                                    border: '1px solid gray',
                                                                    padding: '10px',
                                                                    backgroundColor: '#fff',
                                                                    userSelect: 'none'
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: htmlContent }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                                <div style={{margin: "0 auto"}}>
                                                    <button type="button" className="btn btn-outline-dark"
                                                            onClick={e => navigate(-1)}>
                                                    취소
                                                    </button>
                                                    <button type="button" className="btn btn-outline-dark"
                                                            style={{marginLeft: '10px'}}
                                                            onClick={requestSave}>
                                                        {
                                                            id === null
                                                                ? <span>저장</span>
                                                                : <span>수정</span>
                                                        }
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}